import { VisualisationType } from '@modules/quantify/store/types';

export const isTopSelectionSupported = (
  visualisationType: VisualisationType,
): boolean => {
  return (
    visualisationType === VisualisationType.BAR ||
    visualisationType === VisualisationType.TREND ||
    visualisationType === VisualisationType.PIE
  );
};
